module.exports = __webpack_public_path__ + "static/kincare-preview_925.074cc6d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kincare-preview_925.jpg
// module id = 449
// module chunks = 35783957827783